import { useSelector } from 'react-redux';

import { selectPaymentMethod } from '@cashier/cashier-data-access';

import { AlternativeAmountByPaymentMethodMap } from '../constants';

interface UseAlternativeAmountConfig {
  alternativeAmountConfig: {
    min: number;
    max: number;
    currency: string;
  } | null;
}

export const useAlternativeAmountConfig = (): UseAlternativeAmountConfig => {
  const { id: paymentMethodId } = useSelector(selectPaymentMethod);

  return {
    alternativeAmountConfig:
      AlternativeAmountByPaymentMethodMap[paymentMethodId] || null,
  };
};
